import _actions_get from './_actions/get.js'
import _getters_get_video from './_getters/get_video.js'
import _getters_get_article from './_getters/get_article.js'
import _mutations_set from './_mutations/set.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        set: _mutations_set,
    },
    getters:{
        get_article: _getters_get_article,
        get_video: _getters_get_video,
    },
    actions:{
        get: _actions_get,
    },
}